export type SwitcherBorderColorType = keyof NCoreUIKit.ProjectColorPalette | (string & {});

export type SwitcherBorderColorConstantType = {
    customBorderColor?: keyof NCoreUIKit.ProjectColorPalette | (string & {});
    borderColor?: keyof NCoreUIKit.BorderContentColors | "transparent";
    color?: keyof NCoreUIKit.ContainerContentColors | "transparent";
    colors: NCoreUIKit.ActivePalette["colors"];
};

export const getSwitcherBorderColor = ({
    customBorderColor,
    borderColor,
    colors,
    color
}: SwitcherBorderColorConstantType): SwitcherBorderColorType | undefined => {
    if(customBorderColor) {
        return customBorderColor;
    }

    if(borderColor) {
        return borderColor;
    }

    if(!color) {
        return undefined;
    }

    if(color === "transparent" || colors.content.border[color as keyof NCoreUIKit.BorderContentColors]) {
        return color;
    }

    return undefined;
};
